exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".req-secure-jobs[data-v-841988e2]{background:#fff7ec;border:1px solid rgba(220,135,49,.5);box-sizing:border-box;border-radius:8px;padding:1rem}.SecJo-DeclineButton[data-v-841988e2]{background:#005178;color:#ffff}.req-secure-jobs-container[data-v-841988e2]{display:flex}.req-secure-jobs-column span[data-v-841988e2]{font-weight:700}@media (max-width:480px){.req-secure-jobs-container[data-v-841988e2]{flex-direction:column}}@media (max-width:600px){.SecJo-DeclineButton[data-v-841988e2]{margin-bottom:20px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-841988e2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/components/atoms/request-form/AtomSecureJobsRequestForm.vue
// module id = 1252
// module chunks = 0